import setBuilder from '../../../../../Template/config/components/selection/SetBuilder'
import setBuilderToolbar from './setBuilderToolbar'


export default  {
    ...setBuilder,
    includeSampleSize: false,
    setBuilderToolbar
}


// WEBPACK FOOTER //
// ./src/app/configuration/CategoryWireless/config/components/selection/SetBuilder/index.js